import { useDeleteCustomerMutation } from 'api/user-domain/user-domain';
import { t } from 'i18next';
import ConfirmationDrawer from '../confirmation-drawer/confirmation-drawer.component';
import { Alert, AlertTitle } from '@mui/material';

const DeleteCustomerDrawer = ({ open, close, drawerData, onDelete = null }) => {
  const customerId = drawerData?.customerId;

  const [deleteCustomer] = useDeleteCustomerMutation();

  const handleDeleteCustomer = async userId => {
    await deleteCustomer({ userId, body: {} }).unwrap();
    close();
    onDelete?.();
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      subtitle=""
      color="error"
      onValid={async () => {
        await handleDeleteCustomer(customerId);
      }}
      submitButtonLabel={t('page.customers.card.deleteCustomer')}
      children={
        <Alert severity="error">
          <AlertTitle>
            {t('page.customers.card.deleteCustomerQuestion', {
              email: drawerData?.email,
            })}
          </AlertTitle>
          {t('page.customers.card.deleteCustomerWarning')}
        </Alert>
      }
    />
  );
};

export default DeleteCustomerDrawer;
